import { FunnelSimple, X } from "@phosphor-icons/react";
import { PERIOD_PRESETS } from "@/components/production/pcShared";
import { MultiGroup } from "@/components/production/FiltersSidebar";

const COMPARE_OPTS = [
  { key: "prev", label: "Período anterior" },
  { key: "yoy", label: "Mesmo período ano passado" },
];

export default function BiFiltersSidebar({ options, filters, setFilters, preset, setPreset, onClear, onClose }) {
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  const applyPreset = (p) => {
    setPreset(p.key);
    if (p.range) {
      const [from, to] = p.range();
      setFilters((f) => ({ ...f, date_from: from, date_to: to }));
    }
  };
  return (
    <div className="tile p-3 w-full lg:w-72 shrink-0 lg:sticky lg:top-2 max-h-[calc(100vh-16px)] overflow-y-auto" data-testid="bi-filters-sidebar">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5 font-bold text-sm">
          <FunnelSimple size={16} weight="bold" /> Filtros
        </div>
        <button onClick={onClose} className="text-zinc-400 hover:text-black" data-testid="bi-filters-close">
          <X size={16} />
        </button>
      </div>

      <div className="mb-2">
        <div className="text-xs font-bold uppercase tracking-wide mb-1">Período</div>
        <div className="flex flex-wrap gap-1">
          {PERIOD_PRESETS.map((p) => (
            <button key={p.key} onClick={() => applyPreset(p)}
              className={`text-[10px] px-2 py-1 border rounded ${preset === p.key ? "bg-black text-white border-black" : "border-zinc-300 hover:border-black"}`}
              data-testid={`bi-preset-${p.key}`}>
              {p.label}
            </button>
          ))}
        </div>
        {preset === "custom" && (
          <div className="flex gap-1 mt-1">
            <input type="date" className="input w-1/2 !py-1 text-xs" value={filters.date_from}
              onChange={(e) => set("date_from", e.target.value)} data-testid="bi-date-from" />
            <input type="date" className="input w-1/2 !py-1 text-xs" value={filters.date_to}
              onChange={(e) => set("date_to", e.target.value)} data-testid="bi-date-to" />
          </div>
        )}
        <div className="text-[10px] text-zinc-500 mt-1 font-mono">{filters.date_from} → {filters.date_to}</div>
        {options?.date_min && (
          <div className="text-[10px] text-zinc-400 font-mono">dados: {options.date_min} → {options.date_max}</div>
        )}
      </div>

      <div className="py-2 border-b border-zinc-200 dark:border-zinc-700">
        <div className="text-xs font-bold uppercase tracking-wide mb-1">Comparar com</div>
        <div className="flex flex-wrap gap-1">
          {COMPARE_OPTS.map((c) => (
            <button key={c.key} onClick={() => set("compare", c.key)}
              className={`text-[10px] px-2 py-1 border rounded ${filters.compare === c.key ? "bg-black text-white border-black" : "border-zinc-300 hover:border-black"}`}
              data-testid={`bi-compare-${c.key}`}>
              {c.label}
            </button>
          ))}
        </div>
      </div>

      <MultiGroup label="Loja" testid="bi-filter-stores"
        options={options?.stores || []} selected={filters.stores} onChange={(v) => set("stores", v)} />
      <MultiGroup label="Tipo de Copo" testid="bi-filter-types"
        options={options?.types || []} selected={filters.types} onChange={(v) => set("types", v)} />
      <MultiGroup label="Capacidade (ml)" testid="bi-filter-capacities"
        options={options?.capacities || []} selected={filters.capacities} onChange={(v) => set("capacities", v)} />
      <MultiGroup label="Cor do Copo" testid="bi-filter-colors"
        options={options?.colors || []} selected={filters.colors} onChange={(v) => set("colors", v)} />
      <MultiGroup label="SKU" testid="bi-filter-skus"
        options={options?.skus || []} selected={filters.skus} onChange={(v) => set("skus", v)} />

      <div className="py-2 border-b border-zinc-200 dark:border-zinc-700">
        <div className="text-xs font-bold uppercase tracking-wide mb-1">Quantidade de Copos</div>
        <div className="flex gap-1">
          <input type="number" className="input w-1/2 !py-1 text-xs" placeholder="Mín"
            value={filters.qty_min} onChange={(e) => set("qty_min", e.target.value)} data-testid="bi-filter-qty-min" />
          <input type="number" className="input w-1/2 !py-1 text-xs" placeholder="Máx"
            value={filters.qty_max} onChange={(e) => set("qty_max", e.target.value)} data-testid="bi-filter-qty-max" />
        </div>
      </div>

      <button className="btn w-full mt-3" onClick={onClear} data-testid="bi-clear-filters">
        Limpar Filtros
      </button>
      <div className="text-[10px] text-zinc-400 mt-2">Os filtros são aplicados automaticamente.</div>
    </div>
  );
}
